/** Main site script should go in this file. */

jQuery(document).ready(function() {
	initCustomForms();
	initCycleCarousel();
	initViewBreakpoints();
	initFixedScrollBlock();
	initFilterStaff();
	initMagicScroll();
	setupNav();
	initSlideShow();
	initLogos();
	initResizeDocument();
	initFixFuturedOffset();
	initBreakpoint();
	initShowProjects();
	templateVideos();
});

function initShowProjects() {
	var $button = jQuery('#btn-show-projects');
	var $container = jQuery('#project__section--load');
	if(!$container.length) return;
	$container.hide();
	$button.on('click', function(e) {
		e.preventDefault();
		$container.show();
	});
	// Allow for load more a second time
	var $button2 = jQuery('#btn-show-projects2');
	var $container2 = jQuery('#project__section--load2');
	if(!$container2.length) return;
	$container2.hide();
	$button2.on('click', function(e) {
		e.preventDefault();
		$container2.show();
	});
}

function initMagicScroll() {
	var $slideshow = jQuery('#slideshow-container');
	var win = jQuery(window);
	var $pagination = $slideshow.find('.slideshow__pagination');
	var $bg = $slideshow.find('.slideshow__bg');
	var $slides = $slideshow.find('.slideshow__slide');
	var arrayScenes = [];
	var controller, flagGallery, flagScrollM, paginationAPI, bgAPI, paginationDuration;

	
	if(!$slideshow.length) return;

	win.on('bp:xs bp:sm', function(e){
		if(flagGallery) return
		flagGallery = true;
		flagScrollM = false;
		if(paginationAPI) {
			paginationAPI.destroy(true);
			paginationDuration = undefined;
			paginationAPI = undefined;
		}
		if(bgAPI) {
			bgAPI.destroy(true);
			bgAPI = undefined;
		}
		if(arrayScenes.length) {
			arrayScenes.forEach(function(obj) {
				obj.textScene.destroy(true);
				obj.verticalImgScene.destroy(true);
				obj.horizontalImgScene.destroy(true);
				obj.classLinkScene.destroy(true);
				obj = {};
			});
			arrayScenes = [];
		}
		if(controller) {
			$pagination.find('a').off('click');
			controller.destroy(true);
			controller = undefined;
		}
		$slideshow.css('paddingBottom', 0).fadeGallery({
			slides: '.slideshow__slide',
			btnPrev: '.slideshow__btn-prev',
			btnNext: '.slideshow__btn-next',
			autoRotation: false,
			generatePagination: '.slideshow__switches-outer',
			pagerList: '<ul class="slideshow__switches">',
			pagerListItem: '<li><a href="#" class="slideshow__switch"></a></li>',
			pagerListItemText: ''
		});
	});

	win.on('bp:md bp:lg', function(e){
		if(!window.ScrollMagic) return;
		if(flagScrollM) return;
		flagScrollM = true;
		flagGallery = false;
		$slideshow.fadeGallery('destroy').css('paddingBottom', 500);
		controller = new ScrollMagic.Controller({
			container: this,
			// addIndicators: true,
			globalSceneOptions: {
				triggerHook: 'onLeave'
			}
		});
		$slides.each(function(i) {
			var $slide = jQuery(this);
			var pagerItem = $pagination.find('li').eq(i);
			var currentNum = pagerItem.find('.slideshow__current-num');
			var zero = '0';
			var counter = i + 1;
			var textHolder = $slide.find('.slideshow__text-holder')[0];
			var verticalImg = $slide.find('.slideshow__bg-vertical')[0];
			var horizontalImg = $slide.find('.slideshow__bg-horizontal')[0];
			var height = $slide.innerHeight();
			var obj = {};
			var scrollTextAPI, scrollClassAPI , scrollImgVerAPI, scrollImgHorAPI;

			scrollTextAPI = new ScrollMagic.Scene({
				triggerElement:this,
				duration: height * 0.6  // 60% percent from slide
			}).setPin(textHolder).setClassToggle(textHolder, 'active').addTo(controller);
			
			scrollClassAPI = new ScrollMagic.Scene({
				triggerElement:this,
				duration: height
			}).setClassToggle(pagerItem[0], 'active').addTo(controller);

			scrollImgVerAPI = new ScrollMagic.Scene({
				triggerElement:this,
				duration: height * 0.6  // 60% percent from slide
			}).setPin(verticalImg).setClassToggle(verticalImg, 'active').addTo(controller);
			
			scrollImgHorAPI = new ScrollMagic.Scene({
				triggerElement:this,
				duration: height * 0.6  // 60% percent from slide
			}).setPin(horizontalImg).setClassToggle(horizontalImg, 'active').addTo(controller);

			if(i === 0){
				$slide.addClass('not-animate');
				// add API with most small duration (scrollTextAPI, scrollImgVerAPI or scrollImgHorAPI)
				scrollImgVerAPI.on('leave', function (event) {
					if(event.state === 'AFTER'){
							$slide.removeClass('not-animate')
					} else {
						if(event.scrollDirection === 'REVERSE'){
							$slide.addClass('not-animate');
						}
					}
				});
			}
			if(i === $slides.length - 1){
				// add API with most small duration (scrollTextAPI, scrollImgVerAPI or scrollImgHorAPI)
				scrollImgVerAPI.on('leave', function (event) {
					if(event.state === 'AFTER'){
						$slide.addClass('not-animate');
					} else {
						if(event.scrollDirection === 'REVERSE'){
							$slide.removeClass('not-animate')
						}
					}
				});
			}
			if(!currentNum.length) return;
			if(counter > 9){
				zero = '';
			}
			currentNum.html(zero + counter);
			obj = {
				textScene: scrollTextAPI,
				verticalImgScene: scrollImgVerAPI,
				horizontalImgScene: scrollImgHorAPI,
				classLinkScene: scrollClassAPI,
				slideHeight: height
			}
			arrayScenes.push(obj);
		});

		$pagination.find('a').on('click', function(e) {
			e.preventDefault();
			var index = jQuery(e.target).parent().index();

			// delete this, if you need, don't scroll on click pagination link
			controller.scrollTo(function (newScrollPos) {
				$("html, body").animate({scrollTop: newScrollPos});
			});
			//
			controller.scrollTo(Math.floor($slides.eq(index).offset().top) + 210);
		});
		paginationDuration = function () {
			var result = 0;
			arrayScenes.forEach(function(obj, i) {
				if(i === arrayScenes.length - 1){
					result = result + obj.verticalImgScene.duration();
				} else {
					result = result + obj.slideHeight;
				}
			});
			return result
		}

		paginationAPI = new ScrollMagic.Scene({
			triggerElement: $slideshow[0],
			duration: paginationDuration()
		}).setPin($pagination[0]).addTo(controller);
		
		bgAPI = new ScrollMagic.Scene({
			triggerElement: $slideshow[0],
			duration: paginationDuration()
		}).setPin('.slideshow__bg').addTo(controller);
	});
}
function initFilterStaff() {
	jQuery('.js-filter').categoryFilters({
		categoryAttr: 'data-filter',
		filterLinks: 'a[data-filter]',
		filterBoxes: '.staff__filter-row ',
		filterList: '#staff-filters',
		activeClass: 'filter__active',
		animSpeed: 400,
		addToParent: true,
		effect: 'fade',
		animateSimultaneously: false,
		onInit: function(self) {
			// initial active filter
			var activeLink;
			var dropFlag, listFlag;

			if (self.options.addToParent) {
				activeLink = self.filterLinks.parent().filter('.' + self.options.activeClass).find('a');
			} else {
				activeLink = self.filterLinks.filter('.' + self.options.activeClass);
			}
			if (activeLink.length) {
				self.curLink = activeLink;
				self.refreshClasses();
				self.applyFilter(true);
			}

			var filterList = this.holder.find(this.options.filterList);
			this.chageTitleHolder = function() {
				if(self.curLinkPrev){
					this.$titleOpener.text(self.curLinkPrev.text())
				}
				if(this.curLink === null) return;
				this.$titleOpener.text(this.curLink.text());
			}
			this.switchClass = function() {
				self.$selectHolder.toggleClass('staff-filters__select-holder--active')
			}
			function listToDrop () {
				if (!self.$titleOpener || !self.$outer || !self.$selectHolder) return
				filterList.show().insertAfter(self.$selectHolder);
				self.$titleOpener.off('click');
				self.$titleOpener.remove();
				self.$outer.remove();
				self.$selectHolder.remove();
				self.$titleOpener = undefined;
				self.$selectHolder = undefined;
			}
			function dropToList () {
				self.$titleOpener = jQuery('<a class="staff-filters__opener"></a>');
				self.$outer = jQuery('<div class="staff-filters__outer"></div>');
				self.$selectHolder = jQuery('<div class="staff-filters__select-holder"></div>');

				self.chageTitleHolder();
				self.$selectHolder.insertBefore(filterList);
				filterList.appendTo(self.$outer);
				self.$selectHolder.append(self.$titleOpener).append(self.$outer);
				self.$titleOpener.on('click', self.switchClass);
			}

			jQuery(window).on('bp:xs bp:sm', function(e){
				listFlag = false;
				if(!dropFlag) {
					dropToList();
					dropFlag = true;
				}
			}).on('bp:md bp:lg', function(e) {
				dropFlag = false;
				if(!listFlag) {
					listToDrop();
					listFlag = true;
				}
			});
		},
		onBeforeChange: function(self) {
			if(self.$selectHolder &&  this.$titleOpener) {
				self.switchClass();
				self.chageTitleHolder();
			}
		}
	});
}


function initViewBreakpoints() {

	function moveBlockTo(block, target) {
		var $block = jQuery(block);

		if(!$block.length || !jQuery(target).length ) return;
		if('#' + $block.parent().attr('id') !== target) {
			$block.appendTo(jQuery(target));
		}
	}

	jQuery(window).on('bp:xs', function(e){
		moveBlockTo('#contact__aside', '#contact__anchor');
	}).on('bp:sm bp:md bp:lg', function(e) {
		moveBlockTo('#contact__aside', '#contact__holder');
	});
}

// initialize custom form elements
function initCustomForms() {
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
	});
	jcf.replaceAll();
}

function initFixFuturedOffset() {
	var $container = jQuery('.container').eq(0);
	var $win = $(window);
	var offsetLeft;
	var contents= jQuery('.featured__content');


	function setOffset() {
		offsetLeft = parseInt($container.offset().left);
		contents.css({
			transform: 'translateX(' + offsetLeft + 'px)'
		})
	};

	$win.on('load resize orientationchange', setOffset);
	setOffset();
}


function initResizeDocument() {
	var win = $(window),
			doc = $('html'),
			resizeClass = 'resize-active',
			flag, timer;
	var removeClassHandler = function() {
		flag = false;
		doc.removeClass(resizeClass);
	};
	var resizeHandler = function() {
		if(!flag) {
			flag = true;
			doc.addClass(resizeClass);
		}
		clearTimeout(timer);
		timer = setTimeout(removeClassHandler, 500);
	};
		win.on('resize orientationchange', resizeHandler);
}

function initLogos() {
	var $win = jQuery(window);
	var holders = jQuery('.partners__logo-list');
	
	$win.on('bp:xs bp:sm', function() {
		var holderAPI = holders.data('RandomItems');
		if(holderAPI) return;
		holders.randomItems({
			items: 'img',
			switchTime: 2000,
			itemCols: 6,
		});
	});
	$win.on('bp:md bp:lg', function() {
		var holderAPI = holders.data('RandomItems');
		if(holderAPI) return;
		holders.randomItems({
			items: 'img',
			switchTime: 2000,
			itemCols: 9,
		});
	});
}
// initialize Breakpoint Events
function initBreakpoint(){
	jQuery(window).breakpointEvents({
		defaultBreakpoint: 'xs',
		breakpoints: {
			'sm' :750,
			'md' : 970,
			'lg' : 1170
		}
	});
}


// initialize fixed blocks on scroll
function initFixedScrollBlock() {
	var $win = jQuery(window);
	var $header = jQuery('#header');
	var $block = $header.find('#branding');
	var fixedActiveClass = 'branding--fixed-position';
	var flagFixed, timer;

	if(!$block.length) return;
	
	function setHeight() {
		$header.css({ height: $block.innerHeight() });
	}

	$win.on('load resize orientationchange', function() {
		clearTimeout(timer);
		timer = setTimeout(function() {
			setHeight();
		}, 300)

	})

	$win.on('load scroll', function(e) {
		if($block.offset().top > 0) {
			if(!flagFixed) {
				$block.addClass(fixedActiveClass);
				flagFixed = true;
			}
		} else {
			if(flagFixed) {
				$block.removeClass(fixedActiveClass);
				flagFixed = false;
			}
		}
	});
}


// fade gallery init
function initSlideShow() {
	jQuery('.visual--slideshow').fadeGallery({
		slides: '.slideshow__slide',
		btnPrev: '.slideshow__btn-prev',
		btnNext: '.slideshow__btn-next',
		autoRotation: false,
		animSpeed: 500,
		generatePagination: '.slideshow__switches-outer',
		pagerList: '<ul class="slideshow__switches">',
		pagerListItem: '<li><a href="#" class="slideshow__switch"></a></li>',
		pagerListItemText: '',
		onInit: function() {
			this.slides.each(function(i) {
				var currentNum = jQuery(this).find('.slideshow__current-num');
				var zero = '0';
				var counter = i + 1;

				if(!currentNum.length) return;
				if(counter > 9){
					zero = '';
				}
				currentNum.html(zero + counter);
			})
		},
	});
}

function initCycleCarousel() {
	jQuery('.visual--slideshow-detail').scrollAbsoluteGallery({
		mask: '.slideshow__mask',
		slider: '.slideshow__slideset',
		slides: '.slideshow__slide',
		btnPrev: '.slideshow__btn-prev',
		btnNext: '.slideshow__btn-next',
		pagerLinks: '',
		stretchSlideToMask: true,
		pauseOnHover: false
	});
}

// Initialize main navigation menu and menu behaviors
function setupNav() {

	jQuery('#main-menu__items').smartmenus({
		subIndicatorsPos: 'append',
		subMenusMinWidth: '100%',
		bottomToTopSubMenus: false
	});

	// Menu behaviors 
	var $mainMenuState = jQuery('#main-menu__state');
	if ($mainMenuState.length) {
		$mainMenuState.change(function(e) {
			var $menu = jQuery('#main-menu__items');
			if (this.checked) {
				$menu.hide().slideDown(250, function() { $menu.css('display', ''); });
			} else {
				$menu.show().slideUp(250, function() { $menu.css('display', ''); });
			}
		});
		// Hide mobile menu when window is unloaded 
		// (prevents the menu from being shown on refresh)
		jQuery(window).bind('beforeunload unload', function() {
			if ($mainMenuState[0].checked) {
				$mainMenuState[0].click();
			}
		});
	}
}

function templateVideos() {
	let playButtons = document.querySelectorAll('.banner-video__play');
	if ( playButtons ) {
		playButtons.forEach(play => {
			play.addEventListener('click', (event) => {
				event.preventDefault();
			
				play.classList.toggle('active');
			
				let video = play.previousElementSibling;
				let label = play.querySelector('span.sr-only')
			
				if (video.paused == true) {
					// Play the video
					video.play();
			
					// Update the button text to 'Pause'
					label.innerHTML = "Pause video";
				} else {
					// Pause the video
					video.pause();
			
					// Update the button text to 'Play'
					label.innerHTML = "Play video";
				}
			
			});
		});
	}
}